import * as moment from 'moment';
import { Moment } from 'moment';

export class DriverShift{
    

    shiftid: number;
    startDate:Moment;
    endDate:Moment;
    hours: number;

    constructor(shift:any){
        this.shiftid = shift.shiftid;
        this.startDate = moment(shift.startDate);
        this.endDate = moment(shift.endDate);
        this.hours = shift.hours;
    }

    getRange() : Array<Moment>{
        var range:Array<Moment> = [this.startDate];
        var sDate = moment(this.startDate.toString());
        for(var i = 0; i < this.hours;i++){
            var h = moment(sDate.add(1,'h').toString());
            range.push(h);
        }
        return range;
    }
}